import React from "react";
import { object, string, func } from "prop-types";

import VehicleResultItem from "@components/TestDrive/FilterResultItems/VehicleResultItem";
import ResultItem from "@components/TestDrive/FilterResultItems/FilterResultItem";

import { TEST_DRIVE_TYPE_ID } from "@shared/constants";

const FilterResultItem = ({
  point,
  activePointId,
  accentColor,
  triggerRequestCallback,
  onRequestSuccess,
  onRequestError,
}) => {
  switch (point.type) {
    case TEST_DRIVE_TYPE_ID.LAMAISON:
    case TEST_DRIVE_TYPE_ID.FNAC_DARTY:
    case TEST_DRIVE_TYPE_ID.STORE:
    case TEST_DRIVE_TYPE_ID.HOME:
    case TEST_DRIVE_TYPE_ID.SUPER:
    case TEST_DRIVE_TYPE_ID.MEDIAMARKT:
      return (
        <ResultItem
          testDrivePoint={point}
          isActive={point._id === activePointId}
          triggerRequestCallback={triggerRequestCallback}
          onRequestSuccess={onRequestSuccess}
          onRequestError={onRequestError}
        />
      );

    case TEST_DRIVE_TYPE_ID.F2M:
      return (
        <VehicleResultItem
          point={point}
          isActive={point._id === activePointId}
          accentColor={accentColor}
        />
      );

    default:
      return null;
  }
};

FilterResultItem.propTypes = {
  triggerRequestCallback: func.isRequired,
  onRequestSuccess: func.isRequired,
  point: object.isRequired,
  onRequestError: func.isRequired,
  activePointId: string,
  accentColor: string,
};

export default FilterResultItem;
